import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';

export const MuiButtonBase = {
  defaultProps: { disableRipple: true },
} satisfies Components<Theme>['MuiButtonBase'];
